import * as React from 'react';
import PropTypes from 'prop-types';
import {
    Route, Switch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { IdleTimer } from '../../youwell-common/components';
import { logoutReasons } from '../../youwell-common/constants';

import * as AuthStore from '../../app/store/AuthStore';

import LoadStudents from './components/LoadStudents';
import LoadProgramDetails from './components/LoadProgramDetails';

import Layout from './Layout';
import Home from '../home/Index';
import Student from '../student/Index';
import Program from '../program/Index';
import Resource from '../resource/Index';
import SelectSchool from './components/SelectSchool';
import RegisterSchool from './components/RegisterSchool';
import Users from '../users/Index';

import urls from '../../app/urls';
import LoadProfileData from '../../common/components/LoadProfileData';

const USER_IDLE_TIMEOUT_IN_MINUTES = 30;

class Index extends React.Component {
    logoutOnIdle = () => {
        this.props.logout(logoutReasons.idleTimeout);
    }

    render() {
        const {
            match, appConfig,
        } = this.props;

        // Old code.. All parts should be removed
        // if (profileData?.selectedRole?.organizationName === 'Ukjent skole'
        //     && !location.pathname.startsWith(urls.inside.school.home)) {
        //     return <Redirect to={urls.inside.school.home} />;
        // }

        const studentId = match.params.key === 'student' ? match.params.id : null;

        return (
            <>

                <IdleTimer
                    timeoutInMinutes={USER_IDLE_TIMEOUT_IN_MINUTES}
                    onIdle={this.logoutOnIdle}
                />

                <LoadProfileData />
                <LoadStudents />
                <LoadProgramDetails programId={appConfig?.vimoProgramId} />
                <LoadProgramDetails programId={appConfig?.resourcesProgramId} content />

                <Layout studentId={studentId}>
                    <Switch>
                        <Route exact path={urls.inside.home} component={Home} />
                        <Route path={urls.inside.dashboard} component={Home} />
                        <Route path={urls.inside.profile} component={Home} />
                        <Route path={urls.inside.page} component={Home} />
                        <Route path={urls.inside.form} component={Home} />
                        <Route path={urls.inside.users.home} component={Users} />
                        <Route path={urls.inside.resource.home} component={Resource} />
                        <Route exact path={urls.inside.school.home} component={SelectSchool} />
                        <Route exact path={urls.inside.school.new} component={RegisterSchool} />
                        <Route path={urls.inside.student.home} component={Student} />
                        <Route path={urls.inside.program.home} component={Program} />
                    </Switch>
                </Layout>

            </>
        );
    }
}

Index.propTypes = {
    match: PropTypes.object.isRequired,
    // location: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    // profileData: PropTypes.object,
    appConfig: PropTypes.object.isRequired,
};

Index.defaultProps = {
    // profileData: null,
};

const mapStateToProps = state => ({
    profileData: state.auth.profileData,
    appConfig: state.pageSettings.appConfig,
});

const mapDispatchToProps = dispatch => ({
    logout: bindActionCreators(AuthStore.actionCreators, dispatch).logout,
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
